import { render } from "./CRMAgentQuickMessagesComponent.vue?vue&type=template&id=7f62e754"
import script from "./CRMAgentQuickMessagesComponent.vue?vue&type=script&lang=js"
export * from "./CRMAgentQuickMessagesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__